










































































import { Component, Vue, Watch, Prop } from 'vue-property-decorator';
import { uniq } from 'lodash';
import ThreePanelConditionCategoryList from './components/three-panel-condition-category-list.vue';
import ThreePanelConditionChips from './components/three-panel-condition-chips.vue';
import LoadingCircle from '@/components/loading-circle.vue';
import _ from 'lodash';

@Component({
  components: {
    ThreePanelConditionCategoryList,
    ThreePanelConditionChips,
    LoadingCircle
  }
})
export default class ThreePanelCondition extends Vue {
  @Prop() 
  target: any;

  @Prop() 
  conditions: any;

  @Prop() 
  prefix: string;

  @Prop() 
  loading: boolean;

  @Prop() 
  title: string;

  @Prop()
  labelHelp: string;

  @Prop()
  name: string;

  @Prop() 
  predicates: any[];

  get pPredicates() {
    return this.predicates || this.defaultPredicates;
  }

  get defaultPredicates() {
    return [
      {
        value: 'EQUALS',
        label: this.t('Equals')
      },
      {
        value: 'NOT_EQUALS',
        label: this.t('Not equal')
      }
    ];
  }

  @Prop({ default:  () => [] as any[]})
  data: any[];
  
  selectedDataByCategory: any;

  //loading: boolean = false;
  focused: string = '';
  focusedItem: any = {};
  search_brand: string = '';
  search_model: string = '';

  selected: any[] = [];
  predicate: string = 'EQUALS';
  includeUnknown: boolean = false;
  incomeArray: string[] = []

  mounted() {
    if (this.conditions[this.prefix]) {
      this.predicate = this.conditions[this.prefix].predicate;
      this.includeUnknown = this.conditions[this.prefix].includeUnknown;
    }
  }

  @Watch('data')
  onDataChaged(value: any) {
    if (this.conditions[this.prefix]) {
      this.update(this.conditions[this.prefix].values);
    }
  }

  @Watch('selected')
  onSelectedChanged(value: any[], oldValue: any[]) {
    let groupsAggregated = this.selectedAggregated
      .filter((item: any) => !item.name)
      .map((item: any) => item.brand);

    let namesAggregated = this.selectedAggregated
      .filter((item: any) => item.name)
      .map((item: any) => item.name);

    if(this.selected) {
      this.$set(this.conditions[this.prefix], 'values', groupsAggregated.concat(namesAggregated));
    }
    if(_.isEmpty(this.focusedItem)) {
      this.focusedItem = {
        ...value[0],
        data:this.selectedDataByCategory[value[0]?.brand]?.data
      }
      
    }
  }

  @Watch('predicate')
  onPredicateChanged(value: any[], oldValue: any[]) {
    this.$set(this.conditions[this.prefix], 'predicate', value);
  }

  @Watch('includeUnknown')
  onIncludeUnknownChanged(value: any[], oldValue: any[]) {
    this.$set(this.conditions[this.prefix], 'includeUnknown', value);
  }

  @Watch('conditions', {
    immediate: true
  })
  onConditionsChanged(value: any, oldValue: any) {
    if(!value[this.prefix]) {
      this.$set(this.conditions, this.prefix, {
        values: [],
        predicate: 'EQUALS'
      });
    }
  }


  get items() {
    if (this.search_brand) {
      return this.data.filter((item: any) => {
        return item.name.toLowerCase().includes(this.search_brand.toLowerCase())
      }).slice(0, 100);
    } else {
      return this.data;
    }
  }

  get models() {
    return this.sub_items.filter((item: any) => {
      return item.name.toLowerCase().includes(this.search_model.toLowerCase())
    });
  }

  get sub_items(): any[] {
    const result = this.focusedItem && this.focusedItem.data
      ? this.focusedItem.data.map((model: any) => ({
        name: model,
        brand: this.focusedItem.name,
        //picked: this.is_selected(model),
      }))
      : [];

    return result;
  }

  @Watch('selectedKeysIndex', { deep: true })
  onSelectedKeysIndexChanged(value: any) {
    this.bus.emit(this.prefix + '-selected-keys-index', value);
  }

  toggle(item: any) {
    if (item.data) {
      this.focused = item.name;
      this.focusedItem = item;
    }
    else {
      //item.picked = !item.picked;
      if (!this.is_selected(item.name)) {
        this.add(item);
      } else {
        this.remove(item.name);
      }
    }
  }

  //select, deselect all
  selectAll(item: any) {
    if (!this.is_picked_all(item)) {
      let sub_items = this.sub_items.filter((e) => !this.selectedKeysIndex[e.name]);
      this.selected = this.selected.concat(sub_items);
    } else {
      this.remove(null, this.focusedItem.name, false);
    }

    this.updateBrandSelectAllIndex();
  }

  is_picked_all(item: any) {
    return this.brandSelectAllIndex[item.name];
  }

  modelsDict: any = {};

  getModelsDict() {
    let result: any = {};

    this.data.forEach((brand: any) => {
      brand.data.forEach((model: string) => {
        result[model] = brand.name;
      });
    });

    return result;
  }

  update(values: any) {
    const modelsDict = this.getModelsDict();

    values.forEach((e: string) => {
      const brand = this.is_brand(e);
      if(brand) {
        this.selected = this.selected.concat(brand.data.map((i: any) => {
          return {
            brand: e,
            name: i,
            picked: true,
          }
        }));

        this.updateBrandSelectAllIndex(brand);
      } else {
        this.selected.push({
          brand: modelsDict[e],
          name: e,
          picked: true,
        });
      }
    });
  }

  is_brand(name: string) {
    return this.data.find((e: any) => e.name === name)
  }

  add(item: any, updateIndex: boolean = true) {
    if (!this.is_selected(item.name)) this.selected.push(item);

    if(updateIndex) {
      this.updateBrandSelectAllIndex();
    }
  }

  remove(name?: string, brand?: string, updateIndex: boolean = true) {
    let names: string[] = name
      ? [ name ]
      : this.selected
        .filter((item: any) => item.brand === brand)
        .map((item: any) => item.name);


    let indexes: number[] = [];
    let counter = 0;

    for(let name of names) {
      if (this.selected_keys.indexOf(name) !== -1) {
        indexes.push(this.selected_keys.indexOf(name));
      }
    }

    indexes.sort((a, b) => a > b ? 1 : a < b ? -1 : 0);

    this.selected = this.selected.filter((selected: any, index: number) => !(index === indexes[counter] && ++counter));

    if(updateIndex) {
      this.updateBrandSelectAllIndex();
    }
  }

  brandSelectAllIndex: {[type: string]: boolean} = {};
  updateBrandSelectAllIndex(item: any = this.focusedItem) {
    if(!item.data) return;
    this.$set(this.brandSelectAllIndex, item.name, item.data.every((data: string) => this.selectedKeysIndex[data]));
  }

  @Watch('brandSelectAllIndex', { deep: true })
  onBrandSelectAllIndexChanged(value: any[]) {
    this.bus.emit(this.prefix + '-brand-select-all-index', value);
  }

  is_selected(name: any) {
    return this.selected_keys.indexOf(name) !== -1;
  }

  is_brand_selected(name: any) {
    return this.selected_brands.indexOf(name) !== -1;
  }

  get selected_keys(): string[] {
    return this.selected.map((e: any) => e.name);
  }

  get selectedKeysIndex(): any{
    const result: any = {};
    this.selected_keys.forEach((e: any) => result[e] = true);
    return result
  }

  get selected_brands(): string[] {
    const result = this.selected.map((e: any) => e.brand);
    return result;
  }

  get selected_brands_unique()  {
    const uniqBrands = uniq(this.selected_brands);
    this.selectedDataByCategory=[];
    const result = this.data
      .filter((item: any) => {
        const isIncluded = uniqBrands.includes(item.name);
        if(isIncluded){
          this.selectedDataByCategory[item.name] = item;
        }
        return isIncluded;
      })
      .map((item: any) => ({
        name: item.name,
        isPickedAll: this.brandSelectAllIndex[item.name]
      }));
    return result;
  }

  get selectedAggregated() {
    const result = this.selected_brands_unique
      .map((data: any) => data.isPickedAll
        ? [{
          brand: data.name,
          name: null,
          picked: true
        }]
        : this.selected.filter((item: any) => item.brand === data.name)
      )
      .reduce((a, b) => a.concat(b), []);
    return result;
  }
}
